module.exports = __webpack_public_path__ + "static/note-0033aa5185a655e14e66c438e29976c7.png";